import { CI } from '@/lib';
import type { CustomerInteraction } from '@/lib/customerInteractions/constants';
import type { FiTypes } from '@/types';

export const logInteraction = (
  interaction: CustomerInteraction,
  tabFiType: FiTypes,
  currentFiType: FiTypes,
): void => {
  // Do not log CI if the tab clicked is the one currently rendered
  if (tabFiType !== currentFiType) {
    // If switching from the JP tab to another tab, cancel the JP Redirect CI
    if (
      CI.getClientInteractionEvent(CI.Event.ADD_BANK_REDIRECT_TO_CONSUMER) !==
      undefined
    ) {
      CI.endWith(
        CI.Event.ADD_BANK_REDIRECT_TO_CONSUMER,
        CI.Status.Cancel,
        CI.ErrorReason.User,
      );
    }
    CI.start(interaction);
  }
};
